import Modal from '../utils/accessibility';
class TD_POST_FEED {
  constructor(feedEl) {
    this.setBlockElements(feedEl);

    this.watchEvents();
  }

  setBlockElements(feedEl) {
    this.els = {};
    this.els.block = feedEl;
    this.els.loadMoreButton = this.els.block.querySelector('.alm-load-more-btn.more');
    this.els.sidebarWrap = this.els.block.querySelector('.support_feed__sidebar');
    this.els.filters = this.els.block.querySelectorAll('.alm-filter--link');
    this.els.searchWrap = this.els.block.querySelector('.alm-filter--text-wrap has-button');
    this.els.postsWrap = this.els.block.querySelector('.support_feed__posts_wrap  ');
    this.els.filterTriggers = this.els.block.querySelectorAll('.support_feed__sidebar_toggle');
  }

  watchEvents(){
    // Load More Clicks
    // if(this.els.loadMoreButton){
      // this.els.loadMoreButton.addEventListener('click', () => {
        // do something on load more click
      // });
    // }

    // Filter Clicks
    if(this.els.filters.length){
      this.els.filters.forEach(filter => {
        filter.addEventListener('click', (e) => {
          this.toggleChildFilters(filter);
          this.slideToTop();
        });

        filter.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.code === 'Space') {
            this.toggleChildFilters(filter);
            this.slideToTop(); 
          }
        });
      });
    }

    // Filter Toggle
    if(this.els.filterTriggers.length){
      this.els.filterTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          this.toggleSidebar();
        });
      });
    }
  }

  toggleSidebar() {
    if(this.els.sidebarWrap.classList.contains('active')){
      this.els.sidebarWrap.classList.remove('active');
      this.els.sidebarWrap.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('scroll-lock');
      Modal.close(this.els.sidebarWrap);
      Modal.setToFocusable(this.els.sidebarWrap);
    } else {
      this.els.sidebarWrap.classList.add('active');
      this.els.sidebarWrap.setAttribute('aria-hidden', 'false');
      document.body.classList.add('scroll-lock');
      Modal.open(this.els.sidebarWrap);
    }
  }

  // Toggle child filters if the parent is unchecked
  toggleChildFilters(filter) {
    // Check if the filter is already checked. 
    // This happens before ALM removes the active class from the 
    // filter, so isChecked will be opposite of the filter's class
    const isChecked = !filter.classList.contains('active');

    if(isChecked) return;
    
    const childFiltersList = filter.nextElementSibling;

    if(!childFiltersList) return;

    const activeChildren = childFiltersList.querySelectorAll('.alm-filter--link.active');
    if(activeChildren.length){
      activeChildren.forEach(child => {
        child.classList.remove('active');
        child.setAttribute('aria-checked', 'false');
      });
    }
  }

  slideToTop() {
    const top = this.els.block.getBoundingClientRect().top + window.pageYOffset;;
    // Scroll to the top of the posts wrap
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }
}

// on document load
document.addEventListener('DOMContentLoaded', () => {
  const feeds = document.querySelectorAll('.support_feed');
  if(feeds.length){
    feeds.forEach(feed => {
      feed.postFeed = new TD_POST_FEED(feed);
    });
  }
});
